import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemProdutoListarComponent } from './item-produto-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ItemProdutoListarComponent }
    ])],
    exports: [RouterModule]
})
export class ItemProdutoListarRoutingModule { }
